import { pence } from '@cf/shared';
import { assertReviewed } from './review.js';
import { mulBps } from './bps.js';
export function section24Relief(rules, input) {
    assertReviewed(rules);
    for (const [label, v] of Object.entries(input)) {
        if (!Number.isSafeInteger(v) || v < 0) {
            throw new RangeError(`section24Relief ${label} must be a non-negative integer of pence`);
        }
    }
    const relievable = pence(Math.min(input.financeCosts, input.propertyProfits, input.adjustedTotalIncomeAbovePersonalAllowance));
    return {
        taxReduction: mulBps(relievable, rules.section24.financeCostCreditRateBps),
        unrelievedFinanceCosts: pence(input.financeCosts - relievable),
    };
}
//# sourceMappingURL=section24.js.map